import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDBadgeDot from "components/MDBadgeDot";
import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";
import Icon from "@mui/material/Icon";
import { Chart } from "react-google-charts";
import { SimpleList } from "components/CustomList/SimpleList";
import colors from "assets/theme/base/colors";

// Data
function Labels({ data }) {
  return (
    <MDBox pr={1}>
      {data.labels.forEach((label) => {
        <MDBadgeDot color="dark" size="sm" badgeContent={label}></MDBadgeDot>;
      })}
    </MDBox>
  );
}

function CustomChannelsChart({ title, description, data }) {
  console.log("CustomChannelsChart Data:", data);

  let data_to_show = [["Empresa", "Porcentaje total ventas"]];
  data.labels.forEach((elem, index) => {
    const companySales = data.datasets.data[index];
    data_to_show.push([elem, companySales]);
  });

  const icon = { color: "success", component: "donut_small" };

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox mt={0}>
        <Grid container>
          <Grid item>
            <MDBox py={2} pr={2} pl={icon.component ? 1 : 2}>
              {title || description ? (
                <MDBox display="flex" px={description ? 1 : 0} pt={description ? 1 : 0}>
                  {icon.component && (
                    <MDBox
                      width="4rem"
                      height="4rem"
                      bgColor={icon.color || "info"}
                      variant="gradient"
                      coloredShadow={icon.color || "info"}
                      borderRadius="xl"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      color="white"
                      mt={-5}
                      mr={2}
                    >
                      <Icon fontSize="medium">{icon.component}</Icon>
                    </MDBox>
                  )}
                  <MDBox mt={icon.component ? -2 : 0}>
                    {title && <MDTypography variant="h6">{title}</MDTypography>}
                    <MDBox mb={2}>
                      <MDTypography component="div" variant="button" color="text">
                        {description}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              ) : null}
            </MDBox>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={7}>
            <MDBox>
              <Chart
                chartType="PieChart"
                data={data_to_show}
                options={{
                  colors: data.datasets.backgroundColors.map((color) => {
                    return colors[color].main;
                  }),
                  is3D: false,
                  pieHole: 0.0,
                  pieSliceText: "percentage",
                  pieSliceTextStyle: {
                    color: "black",
                    fontSize: "14",
                  },
                  // pieSliceText: "label",
                  chartArea: { left: 10, top: 10, width: "100%", height: "90%" },
                  legend: "none",
                  tooltip: { showColorCode: true, trigger: "selection" },
                }}
                width={"100%"}
                height={"300px"}
              />
            </MDBox>
          </Grid>
          <Grid item xs={5}>
            <SimpleList labels={data.labels} colors={data.datasets.backgroundColors}></SimpleList>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}
CustomChannelsChart.defaultProps = {
  title: "",
  description: "",
  data: [],
};

// Typechecking props for the PieChart
CustomChannelsChart.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  data: PropTypes.object,
};

Labels.defaultProps = {
  data: {},
};
Labels.propTypes = {
  data: PropTypes.object,
};

export default CustomChannelsChart;
